import React, { useContext } from 'react';
import CardHeader from '../../../molecules/card-header/CardHeader';
import { Button, ButtonProps } from '../../button';
import { CheckType, ShowExtendedDeleteViewProps } from './types';
import { CardHeaderProps } from '../../../molecules/card-header/CardHeader';
import { TableContext } from '../Table/provider/Provider';

interface Props {
  header: CardHeaderProps;
  showExtendedDeleteView: ShowExtendedDeleteViewProps;
  check: CheckType;
  selectButtonLabel?: string;
  selectButtonProps?: ButtonProps;
}

function Header({
  header,
  showExtendedDeleteView,
  check,
  selectButtonLabel,
  selectButtonProps,
}: Props) {
  const { selectedIdsData } = useContext(TableContext);
  return (
    <CardHeader
      className="rounded-top-4 border-bottom"
      {...header}
      portal
      {...(selectedIdsData.selectedIds.length > 0 &&
        !showExtendedDeleteView?.showExtendedDelete && {
          buttons: [
            <Button
              fill="fill"
              key={1}
              size="md"
              type="danger"
              {...selectButtonProps}
              onClick={() => check?.onClickDelete(selectedIdsData.selectedIds)}
            >
              {selectButtonLabel}
            </Button>,
          ],
        })}
    />
  );
}

export default Header;
